import { render, staticRenderFns } from "./OperationalInventoryAssignToGarageAndDuty.vue?vue&type=template&id=15c6d6d2&"
import script from "./OperationalInventoryAssignToGarageAndDuty.vue?vue&type=script&lang=js&"
export * from "./OperationalInventoryAssignToGarageAndDuty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports